import { Column, Row } from '~components/table-view';
import FundingSourceBadges from '~support-at-home/components/claims/reconciliations-wizard/FundingSourceBadges';

export const columns: Column[] = [
  {
    id: 'meta_budgets',
    header: 'Affected Funding',
    type: 'custom',
    style: { width: '400px' },
    component: FundingSourceBadges,
    componentProps: (row: Row) => ({
      meta_budgets: row?.meta_budgets || [],
      funding_sources: row?.funding_sources || [],
    }),
    classNames: {
      header: 'cell-align-left',
      column: 'cell-align-left',
    },
  },
  {
    id: 'service_name',
    header: 'Service',
    type: 'text',
    style: { width: '150px' },
    classNames: {
      header: 'cell-align-left',
      column: 'cell-align-left',
    },
  },
  {
    id: 'service_date',
    header: 'Service Date',
    type: 'date',
    style: { width: '120px' },
    classNames: {
      header: 'cell-align-center',
      column: 'cell-align-center',
    },
  },
  {
    id: 'claimed',
    header: 'Claimed',
    type: 'currency',
    classNames: {
      header: 'cell-align-right',
      column: 'cell-align-right',
    },
  },
  {
    id: 'gov_contribution_amount',
    header: 'Govt. Contribution',
    type: 'currency',
    classNames: {
      header: 'cell-align-right',
      column: 'cell-align-right',
    },
  },
  {
    id: 'co_contribution_amount',
    header: 'Co-Contribution',
    type: 'currency',
    classNames: {
      header: 'cell-align-right',
      column: 'cell-align-right',
    },
  },
  {
    id: 'paid',
    header: 'Paid',
    type: 'currency',
    classNames: {
      header: 'cell-align-right',
      column: 'cell-align-right',
    },
  },
];
